import { FLASH_NODE_MODELS } from './partNumbers.jsx';
import { dualCpuFlashEligible } from '../domain/rules/dualCpuRules';

/**
 * CONF-210. Resolve which flash (F-node) hardware a config uses.
 *
 * The ONE seam between `afaNodeModel` on the config and the FLASH_NODE_MODELS
 * table. Part numbers, NIC counts, pricing, BOM rows, network ports, metrics
 * power/weight, labels, the CCI gate and the product offering all come
 * through here, so they cannot disagree.
 *
 * Eligibility is applied here as well as in rule R13, because two paths
 * reach pricing without the rules having run: the AI optimizer builds
 * candidates with {...config} and calls the engines directly, and a legacy
 * quote can be loaded on a vendor switch. A stale 'dualCpu' on DELL/SMC or
 * with the kill switch off therefore resolves to the single-CPU node rather
 * than pricing a SKU the vendor cannot supply.
 *
 * Lives in its own module: partNumberUtils.jsx already imports networkPorts.js
 * and both need this, so hosting it in either would create a cycle.
 */
export const resolveFlashNodeModel = (config) => {
  if (config?.afaNodeModel === 'dualCpu' && dualCpuFlashEligible(config.hardwareVendor)) {
    return FLASH_NODE_MODELS.dualCpu;
  }
  return FLASH_NODE_MODELS.standard;
};

/**
 * Whether this quote actually ships Dual CPU flash nodes: the flash set must
 * be on and sized, not merely carry the flag. Used by the CCI gate and by
 * labels that describe what is being quoted.
 */
export const isDualCpuFlashQuote = (config) =>
  Boolean(config?.afaEnabled)
  && (config.afaNodeCount || 0) > 0
  && resolveFlashNodeModel(config).id === 'dualCpu';
